import { CatalogAdjustmentTypePage } from "./CatalogAdjustmentTypePage";

const CatalogAdjustmentType = () => {
	return <CatalogAdjustmentTypePage />;
};
export default CatalogAdjustmentType;
